<div class="overflow-x-scroll">
  <ng-container *ngIf="dataTable.dataSource.loading$ | async">
    <mat-progress-bar mode="indeterminate" />
  </ng-container>

  <table
    mat-table
    matSort
    [dataSource]="dataTable.dataSource"
    [trackBy]="trackByAppointment"
  >
    <ng-container matColumnDef="appointment-date">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Appointment Date
      </th>
      <td *matCellDef="let row" mat-cell class="truncate">
        @if (row.appointment.event; as event) {
          <pr-formatted-event-field
            field="from"
            [event]="event"
            [format]="dateFormat"
          />
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="patient-name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Patient
      </th>
      <td *matCellDef="let row" mat-cell class="truncate">
        <a
          [prBrandRouterLink]="(row.patient | map: brandLinks.patient).segments"
        >
          {{ row.patient.name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="practitioner">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Practitioner
      </th>
      <td *matCellDef="let row" mat-cell class="truncate">
        {{ row.appointment.practitioner.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="treatment">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Treatment
      </th>
      <td *matCellDef="let row" mat-cell class="truncate">
        {{ row.appointment.treatmentPlan.treatmentStep.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="deposit">
      <th *matHeaderCellDef mat-header-cell mat-sort-header class="truncate">
        Deposit
      </th>
      <td *matCellDef="let row" mat-cell class="truncate">
        @if (row.appointment.deposit?.metadata; as deposit) {
          <pr-deposit-status-chip [deposit]="deposit" />
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef mat-header-cell class="truncate"></th>
      <td *matCellDef="let row" mat-cell class="truncate">
        <div class="flex items-center justify-center gap-1">
          <button
            mat-icon-button
            color="primary"
            matTooltip="Take Deposit"
            (click)="recordDeposit.emit(row)"
          >
            <mat-icon>attach_money</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="View appointment on the timeline"
            (click)="viewAppointment.emit(row)"
          >
            <mat-icon>event</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="dataTable.displayColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: dataTable.displayColumns" mat-row></tr>
  </table>
</div>
